import {
  LE_CONTRACTED_HOTEL_TYPES,
  OFFER_TYPE_BED_BANK,
  OFFER_TYPE_BUNDLE_AND_SAVE,
  OFFER_TYPE_VILLA,
} from 'constants/offer'
import { queryKeyLegacyOfferTypes, queryKeyLegacyRental } from 'constants/url'
import { deleteSearchParams } from 'lib/url/searchUrlUtils'

export const UNSUPPORTED_LISTING_QUERY_KEYS = [queryKeyLegacyRental, queryKeyLegacyOfferTypes] as const

export const HOTEL_SEARCH_OFFER_TYPES: Array<App.OfferListOfferType> = [
  ...LE_CONTRACTED_HOTEL_TYPES,
  OFFER_TYPE_BUNDLE_AND_SAVE,
  OFFER_TYPE_BED_BANK,
  OFFER_TYPE_VILLA,
]

export function sanitizeUnsupportedListingSearchParams(search: string): string {
  return deleteSearchParams(search, ...UNSUPPORTED_LISTING_QUERY_KEYS)
}
